export interface LoadUserSettingOutputApiModel{
    completed_first_story: boolean,
    completed_schedule: boolean,
    completed_invite_member: boolean
}